// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lswaw{margin:12px 28px 0}.apLaC{display:flex;gap:10px;align-items:center}.apLaC .XhZov{width:fit-content}.apLaC .XhZov:has(+.eUfRL){min-width:fit-content;flex:1}.apLaC .eUfRL{flex:1}.RGRRg{max-width:400px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"automaticBillingAtContent": `lswaw`,
	"automaticBillingAtDropdownMenu": `apLaC`,
	"dropdownMenu": `XhZov`,
	"datePicker": `eUfRL`,
	"menuItem": `RGRRg`
};
export default ___CSS_LOADER_EXPORT___;
